<template>
  <div class="teachers-page">
    <!-- 顶部横幅 -->
    <div class="teachers-banner">
      <div class="banner-content" data-aos="fade-down">
        <h1>师资力量</h1>
        <p>卓越的艺术家与教育家团队</p>
        <div class="banner-badges">
          <span class="badge">名师荟萃</span>
          <span class="badge">严选教学</span>
          <span class="badge">升学保障</span>
        </div>
      </div>
    </div>

    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <div class="container">
        <router-link to="/">首页</router-link>
        <span> / </span>
        <span>师资力量</span>
      </div>
    </div>

    <div class="container">
      <!-- 师资概况 -->
      <section class="teachers-intro" data-aos="fade-up">
        <div class="intro-content">
          <div class="intro-text">
            <h2 style="margin-top: 0;">我们的教师团队</h2>
            <p>&emsp;&emsp;杉原美校拥有一支专业的美术教师团队，教师们均毕业于国内知名美术院校，拥有丰富的教学经验和专业技能。</p>
            <p>&emsp;&emsp;我们的教师不仅在教学上精益求精，更在艺术创作和研究领域取得优异成绩，为学生提供专业的美术指导和艺术熏陶。</p>
            <div class="stats-grid">
              <div class="stat-item">
                <div class="stat-number">30+</div>
                <div class="stat-label">专业教师</div>
              </div>
              <!--<div class="stat-item">-->
              <!--  <div class="stat-number">15+</div>-->
              <!--  <div class="stat-label">教学经验</div>-->
              <!--</div>-->
              <!--<div class="stat-item">-->
              <!--  <div class="stat-number">98%</div>-->
              <!--  <div class="stat-label">学生满意度</div>-->
              <!--</div>-->
              <!--<div class="stat-item">-->
              <!--  <div class="stat-number">95%</div>-->
              <!--  <div class="stat-label">升学率</div>-->
              <!--</div>-->
            </div>
          </div>
          <!--<div class="intro-image">-->
          <!--  <el-image-->
          <!--      :src="headerImage"-->
          <!--      :preview-src-list="[headerImage]"-->
          <!--      lazy>-->
          <!--  </el-image>-->
          <!--</div>-->
        </div>
      </section>

      <!-- 教师列表 -->
      <section class="teachers-list" data-aos="fade-up">
        <div class="list-header">
          <h3>教师名录</h3>
        </div>

        <div class="teachers-grid">
          <div class="teacher-card shiny" v-for="teacher in paginatedTeachers"
               :key="teacher.id" @click="showTeacherDetail(teacher)" :data-aos="cardAosName">
            <div class="teacher-image">
              <img :src="teacher.image" :alt="teacher.name" loading="lazy" />
            </div>
            <div class="teacher-info">
              <h3 class="teacher-name">{{ teacher.name }}</h3>
              <div class="teacher-description">
                <p
                    v-for="(line, i) in teacher.descriptions"
                    :key="i"
                    class="teacher-line"
                >
                  • {{ line }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="teacher-wall" data-aos="fade-up"
               v-for="(item, index) in wallTeacher" :key="index"
               :class="[{'pt-20': index > 0}]">
        <div class="wall-header">
          <h3>{{ item.title }}</h3>
          <p>教师形象照速览</p>
          <div class="wall-divider"></div>
        </div>
        <div class="wall-teacher-card" v-for="teacher in item.teachers" :key="teacher">
          <div class="wall-teacher-image">
            <img :src="require(`@/assets/resources/教师介绍/教师形象照/${teacher}.jpg`)" loading="lazy">
          </div>
          <div class="wall-teacher-name">{{ teacher }}</div>
        </div>
      </section>
    </div>

    <div style="height: 40px;width: 100%;"></div>

    <!-- 教师详情模态框 -->
    <transition name="modal-fade-zoom">
      <div
        v-if="selectedTeacher"
        class="teacher-modal"
        role="dialog"
        aria-modal="true"
        @click.self="closeTeacherDetail"
      >
        <div class="modal-content">
          <button class="close-button" @click="closeTeacherDetail" aria-label="关闭">×</button>
          <div class="modal-header">
            <div class="modal-image">
              <img :src="selectedTeacher.image" :alt="selectedTeacher.name" loading="lazy" />
            </div>
            <div class="modal-title">
              <h3>{{ selectedTeacher.name }}</h3>
              <p class="title">{{ selectedTeacher.title }}</p>
              <p><strong>学院：</strong>{{ selectedTeacher.department }}</p>
              <p><strong>专业：</strong>{{ selectedTeacher.specialty }}</p>
              <p><strong>学历：</strong>{{ selectedTeacher.education }}</p>
              <p><strong>经验：</strong>{{ selectedTeacher.experience }}</p>
            </div>
          </div>
          <div class="modal-body">
            <div class="bio-section">
              <h4>教师简介</h4>
              <p>{{ selectedTeacher.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'TeachersView',
  data() {
    return {
      // 筛选条件
      selectedDepartment: '',
      selectedTitle: '',
      selectedSpecialty: '',
      searchQuery: '',

      // 排序
      sortBy: 'name',
      sortOrder: 'asc',

      // 增量加载
      visibleCount: 8,
      pageStep: 8,
      wallVisibleCount: 12,
      wallStep: 12,
      cardAosName: window && window.innerWidth < 768 ? '' : 'zoom-in',

      headerImage: require('@/assets/resources/往年毕业照摘录/杉原学校2025集体照.jpg'),

      // 选中的教师
      selectedTeacher: null,
      itemsPerPage: 10,

      teacherImages: [],
      // 教师数据
      teachers: [
        {
          id: 1,
          name: "刘俊",
          descriptions: [
            "杉原美术学校创始人，2000年从中国美术学院本科毕业后，考入西安美术学院硕士就读油画专业。2003年在长治市区开始创办画室至今。",
            "全国色彩名师",
            "中国美术学院本科毕业",
            "西安美术学院研究生",
            "从教20余年",
            "培养出全山西省统考三名状元",
            "以及八十余位名校第一名"
          ],
          image: require("@/assets/resources/教师介绍/教师形象照/刘俊.jpg")
        },
        {
          id: 14,
          name: "普烨",
          descriptions: [
            "教龄：10年",
            "毕业院校：淮北师范大学",
            "进修经历：多次参加山西美术联盟速写名师班进修；连续多年在全省美术教学峰会与名师讨论考试方向；全国名师速写创作强化班。",
            "教学成绩：从教10年，累计带出千余名美术生，其中百余名考入一本院校；所带班级速写成绩优异，过线率达93%以上。",
            "教育格言：美术的魅力在于无限可能，与孩子们共赴这场美的盛宴，一起去发现身边无处不在的美。"
          ],
          image: require("@/assets/resources/教师介绍/教师形象照/普烨.jpg")
        },
        {
          id: 4,
          name: "李欣怡",
          descriptions: [
            "教龄：6年",
            "毕业院校：长春工业大学",
            "进修：多次参与各地美术名师培训，曾赴济南、太原、合肥等多个城市深造。通过系统学习与交流，博采众长，有效提升了自身的艺术教学与创作水平。",
            "教学成绩：所带班级升学率百分之九十以上",
            "优秀学生：2020年联考长治第一，每年有985以及211",
            "教育格言：教育不是注满一桶水，而是点燃一把火"
          ],
          image: require("@/assets/resources/教师介绍/教师形象照/李欣怡.jpg")
        },
        {
          id: 3,
          name: "杨伟光",
          descriptions: [
            "教龄：8年",
            "毕业院校：延安大学鲁迅艺术学院",
            "进修经历：2021年参与山西省高考美术命题趋势培训，2019-2025年连续六年参与色彩科目名师教培",
            "教学成绩：近3年所带高考美术生色彩科目合格率100%，2024届12人考入“双一流”大学，2人获全市专业前10名",
            "教育格言：“以笔为媒传美学，以心为灯引方向，让每个美术生都能绘出理想未来。”"
          ],
          image: require("@/assets/resources/教师介绍/教师形象照/杨伟光.jpg")
        },
        {
          id: 11,
          name: "陕姗晨",
          descriptions: [
            "教龄：9年",
            "毕业院校：哈尔滨理工大学",
            "进修经历：每年坚持参与青竹教师研修班，持续深化教学能力与教育理念。",
            "教学成绩：所带毕业班升学率连续稳定在85%以上，最高超94%；2025届学生王旭菡以243分高分考入太原理工大学，2023届学生徐梦鑫以251.4分获长治市第二名。",
            "教育格言：以耐心倾听成长，用专业点亮方向，让每个孩子都成为独一无二的发光体。"
          ],
          image: require("@/assets/resources/教师介绍/教师形象照/陕珊晨.jpg")
        },
        {
          id: 15,
          name: "李晋",
          descriptions: [
            "教龄：8年",
            "毕业院校：成都大学",
            "进修经历：安徽阜阳闵亮亮素描培训学习，杭州吕铮铮、师峰、谢延楠素描名师班培训，太原蔡亚男素描培训学习。",
            "教学成绩：教学成绩优异，均分高于平均分，带出多名80分以上高分学生。2020年247分姚佳怡，2021年248分王东宇，2022年251分靳紫琼，2023年251分，2024年252分马亚茜。",
            "教育格言：生活中并不缺少美，而是缺少发现美的眼睛。"
          ],
          image: require("@/assets/resources/教师介绍/教师形象照/李晋.jpg")
        },
        {
          id: 8,
          name: "李星",
          descriptions: [
            "教龄：11年",
            "毕业院校：中央美术学院本科、中国美术学院研究生毕业",
            "进修经历：吕铮铮、鲍冬冬、万贤峰、刘学松美术高考进修班等省内外名师研修班。",
            "教学成绩：辅导学生1000+，各大本科院校录取900+。",
            "教育格言：教育是静待花开的艺术。用爱心与耐心浇灌，尊重每个生命的独特节奏，他们终将绽放属于自己的光彩。"
          ],
          image: require("@/assets/resources/教师介绍/教师形象照/李星.jpg")
        },
        {
          id: 16,
          name: "范志远",
          descriptions: [
            "教龄：10年",
            "毕业院校：山西师范大学",
            "进修经历：太原博艺画室、太原生钰学校、北京010画室、石家庄尚艺画室任素描主教；杭州吕铮铮、师峰、谢延楠素描名师班培训。",
            "教学成绩：教学成绩优异，均分高于平均分，带出多名85分以上高分学生。",
            "教育格言：美术是技术与审美的融合，我会以专业态度、严谨教学，为学生打造坚实的艺术根基。"
          ],
          image: require("@/assets/resources/教师介绍/教师形象照/范志远.jpg")
        },
        {
          id: 9,
          name: "李亮",
          descriptions: [
            "教龄：11年",
            "毕业院校：西安美院",
            "进修经历：2015-2022年多次往返于北京、杭州、重庆、西安等地参加全国名师高考研修班，为《敲门砖》《争霸联考》《烈公文化》等书籍提供书籍画稿。",
            "教学成绩：十一年教学经验，始终奋斗在教学一线，具有强烈的工作责任心。教学风趣幽默，知识点剖析明确清晰，拥有系统的教学体系。2013-2024年培养多个省联考素描单科状元，2024年所带班级素描均分80分以上。",
            "教育格言：“用心激励、唤醒、鼓舞每一位学生！”"
          ],
          image: require("@/assets/resources/教师介绍/教师形象照/李亮.jpg")
        },
        {
          id: 10,
          name: "王倩",
          descriptions: [
            "教龄：6年",
            "毕业院校：郑州轻工业大学",
            "进修经历：曾在河南省头部画室壹零陆任职3年，参与多地美术教学课题培训，袁亮、刘同飞、吕铮铮素描研修班，颜苏平色彩线下研修班。",
            "教学成绩：6年间助力超200名学生考入理想艺术院校，本科上线率达90%，所带班级学生河南省美术统考平均分230分（满分300）。",
            "教育格言：用艺术之光照亮学生成长之路。"
          ],
          image: require("@/assets/resources/教师介绍/教师形象照/王倩.jpg")
        },
        {
          id: 2,
          name: "王瑞君",
          descriptions: [
            "教龄：5年",
            "毕业院校：山东工艺美术学院",
            "进修经历：2024年蔡亚楠素描研修。2025年万贤锋速写创作研修等多位素描名师培训。",
            "教学成绩：近几年所带班级学生合格率94%以上",
            "教育格言：“教不严，师之惰。”“玉不琢，不成器；人不学，不知道。”"
          ],
          image: require("@/assets/resources/教师介绍/教师形象照/王瑞君.jpg")
        },
        {
          id: 5,
          name: "段宁",
          descriptions: [
            "教龄：5年",
            "毕业院校：四川师范大学",
            "进修经历：曾多次参与山西省、四川省美术名师课题培训，获高级美术教师资格认证",
            "教学成绩：所带三届考生本科升学率均超90%，多名学生考入985、美术学院等顶尖院校，指导学生多次在省级美术赛事中获奖",
            "教育格言：“以笔为刃，以心为灯，陪每颗追梦的心闯过联考关，抵达理想岸。”"
          ],
          image: require("@/assets/resources/教师介绍/教师形象照/段宁.jpg")
        },
        {
          id: 6,
          name: "段鑫方",
          descriptions: [
            "教龄：5年",
            "毕业院校：晋中学院",
            "进修经历：多次参加省级美术教育课题培训，获得中高级美术教师资格认证，多次参加省级名师培训。",
            "教学成绩：往届高三学生升学率高达95％，专升本成绩高达98％。",
            "教育格言：“热爱，可抵岁月漫长；坚持，可抵万难荆棘。”"
          ],
          image: require("@/assets/resources/教师介绍/教师形象照/段鑫方.jpg")
        },
        {
          id: 17,
          name: "杨豫林",
          descriptions: [
            "教龄：5年",
            "毕业院校：湖南理工大学",
            "进修经历：美术素描专业进修于湖南省十方尚品教育机构系统完成为期六个月的高级素描课程。2022年安徽阜阳素描集中培训一个月。",
            "教学成绩：2022届所带66名学员，89%通过省内美术联考，班级平均分212，远超省平均线197。其中5名学生跻身全省前200，最高分254（全省排名前50）。",
            "教育格言：好好学习，天天向上。"
          ],
          image: require("@/assets/resources/教师介绍/教师形象照/杨豫林.jpg")
        },
        {
          id: 7,
          name: "张琪",
          descriptions: [
            "教龄：4年",
            "毕业院校：山西传媒学院",
            "进修经历：2022年至2025年山西省内外名师色彩研修班，2020年优秀毕业生，在校期间参加山西省传媒类艺术类统考工作，曾多次参与监考、阅卷等工作。",
            "教学成绩：近3年所带美术生班级专业联考通过率100%，其中12名学生考入省重点艺术类院校；本科通过率达94.5%",
            "教育格言：以色彩为笔，绘就学生艺术梦想；以耐心为舟，载引学子探索美学之境。"
          ],
          image: require("@/assets/resources/教师介绍/教师形象照/张琪.jpg")
        },
        {
          id: 13,
          name: "段凝婧",
          descriptions: [
            "教龄：3年",
            "教育背景：合肥工业大学",
            "专业进修：曾参加鲍东东色彩专项培训，作品荣获安徽设计展第二名。",
            "教学成果：高中美术班联考通过率92%，专升本升学率95%。",
            "教学理念：秉持“每天多一点赞赏，每天多一点鼓励”的信念，注重激发学生自信与创造力，营造积极温暖的学习氛围。"
          ],
          image: require("@/assets/resources/教师介绍/教师形象照/段凝婧.jpg")
        },
        {
          id: 100,
          name: "张晓鹏",
          descriptions: [
            "教龄：3年",
            "毕业学校:山东工艺美术学院",
            "经历:在职期间多次参加省内外名师研修，不断提升自我，总结经验完善自己的教学理念。了解针对不同发展阶段的差异化教学，能够快速理解学生需求并因材施教。",
            "教育格言:每个孩子都有自己的色彩，所谓成长，不过是他们在人间，慢慢挑选属于自己的色彩。",
          ],
          image: require("@/assets/resources/教师介绍/教师形象照/张晓鹏.jpg")
        },
        {
          id: 12,
          name: "李鑫琪",
          descriptions: [
            "教龄：2年",
            "毕业学校：山西大学商务学院",
            "经历：在职期间多次参加省内外名师研修；在校期间担任学生会核心成员，策划多项大型校园活动；担任美术部长带领部门完成创意项目；获学院创意大赛特等奖。",
            "教育格言：技术传授和美学培养同样重要。"
          ],
          image: require("@/assets/resources/教师介绍/教师形象照/李鑫琪.jpg")
        },
      ],
      wallTeacher: [
        {title: '色彩教学团队', teachers: ['刘俊', '李欣怡', '杨伟光', '段宁', '段鑫方', '张琪', '段凝婧', '李鑫琪']},
        {title: '素描教学团队', teachers: ['李晋', '范志远', '李亮', '王倩', '杨豫林']},
        {title: '创作教学团队', teachers: ['普烨', '王瑞君', '李星', '陕珊晨', '张晓鹏']},
        {title: '管理团队', teachers: ['刘燕飞', '李慧慧', '郭玉翠', '王梦', '郝婷婷']},
      ]
    }
  },
  computed: {
    // 院系列表
    departments() {
      return [...new Set(this.teachers.map(teacher => teacher.department))];
    },
    // 职称列表
    titles() {
      return [...new Set(this.teachers.map(teacher => teacher.title))];
    },
    // 专业方向列表
    specialties() {
      return [...new Set(this.teachers.map(teacher => teacher.specialty))];
    },
    // 筛选后的教师列表
    filteredTeachers() {
      let result = [...this.teachers];

      // 按院系筛选
      if (this.selectedDepartment) {
        result = result.filter(teacher => teacher.department === this.selectedDepartment);
      }

      // 按职称筛选
      if (this.selectedTitle) {
        result = result.filter(teacher => teacher.title === this.selectedTitle);
      }

      // 按专业方向筛选
      if (this.selectedSpecialty) {
        result = result.filter(teacher => teacher.specialty === this.selectedSpecialty);
      }

      // 按搜索关键词筛选
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        result = result.filter(teacher =>
          teacher.name.toLowerCase().includes(query) ||
          teacher.department.toLowerCase().includes(query) ||
          teacher.specialty.toLowerCase().includes(query)
        );
      }

      // 排序
      result.sort((a, b) => {
        let valueA = a[this.sortBy];
        let valueB = b[this.sortBy];

        if (typeof valueA === 'string') {
          valueA = valueA.toLowerCase();
          valueB = valueB.toLowerCase();
        }

        if (this.sortOrder === 'asc') {
          return valueA > valueB ? 1 : -1;
        } else {
          return valueA < valueB ? 1 : -1;
        }
      });

      return result;
    },
    // 分页后的教师列表
    paginatedTeachers() {
      return this.teachers
      // return this.filteredTeachers.slice(0, this.visibleCount)
    },
    teacherImagesVisible() {
      return this.teacherImages.slice(0, this.wallVisibleCount)
    },
    // 总页数
    totalPages() {
      return Math.ceil(this.filteredTeachers.length / this.itemsPerPage);
    }
  },
  created() {
    // this.loadTeacherImages();
  },
  methods: {
    loadMore() {
      this.visibleCount = Math.min(this.visibleCount + this.pageStep, this.filteredTeachers.length)
    },
    loadMoreWall() {
      this.wallVisibleCount = Math.min(this.wallVisibleCount + this.wallStep, this.teacherImages.length)
    },
    loadTeacherImages() {
      // 自动读取 assets 目录下所有 .jpg 文件
      const requireContext = require.context(
          '@/assets/resources/教师介绍/教师形象照/',
          false,
          /\.jpg$/
      );

      const images = requireContext.keys().map(key => ({
        image: requireContext(key),
        name: key.replace('./', '').replace('.jpg', '')
      })).filter(o => {
        return !['行政李彬校长','李校长'].includes(o.name)
      });

      // 需要的排序顺序
      const order = [
        "刘俊",
        // "行政李彬校长",
        // "李校长",
        "刘燕飞",
        "李慧慧",
        "普烨",
        "李欣怡",
        "杨伟光",
        "陕姗晨",
        "李晋",
        "李星",
        "范志远",
        "张琪"
      ];

      // 先分为：在 order 中的 和 不在 order 中的
      const ordered = [];
      const unordered = [];

      images.forEach(img => {
        if (order.includes(img.name)) {
          ordered.push(img);
        } else {
          unordered.push(img);
        }
      });

      // 按 order 顺序排
      const sortedOrdered = order
          .map(name => ordered.find(o => o.name === name))
          .filter(Boolean);

      // 其余老师随机打乱
      const shuffledUnordered = unordered.sort(() => Math.random() - 0.5);

      // 拼接结果
      this.teacherImages = [...sortedOrdered, ...shuffledUnordered];
    },
    // 处理搜索
    handleSearch() {
      this.visibleCount = this.pageStep;
    },
    // 排序教师列表
    sortTeachers(field) {
      if (this.sortBy === field) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortBy = field;
        this.sortOrder = 'asc';
      }
    },
    // 显示教师详情
    showTeacherDetail(teacher) {
      console.log(teacher)
      // this.selectedTeacher = teacher;
      // document.body.style.overflow = 'hidden';
    },
    // 关闭教师详情
    closeTeacherDetail() {
      this.selectedTeacher = null;
      document.body.style.overflow = '';
    }
  },
  mounted() {
    // 底部哨兵自动增量加载
    // const sentinel = this.$refs.sentinel
    // if (sentinel && 'IntersectionObserver' in window) {
    //   const observer = new IntersectionObserver((entries) => {
    //     entries.forEach((e) => {
    //       if (e.isIntersecting) {
    //         this.loadMore()
    //       }
    //     })
    //   }, { rootMargin: '200px' })
    //   observer.observe(sentinel)
    //   this._listObserver = observer
    // }
    // const wall = this.$refs.wallSentinel
    // if (wall && 'IntersectionObserver' in window) {
    //   const ob2 = new IntersectionObserver((entries) => {
    //     entries.forEach((e) => { if (e.isIntersecting) this.loadMoreWall() })
    //   }, { rootMargin: '200px' })
    //   ob2.observe(wall)
    //   this._wallObserver = ob2
    // }
  },
  beforeDestroy() {
    // if (this._listObserver) this._listObserver.disconnect()
    // if (this._wallObserver) this._wallObserver.disconnect()
  },
  watch: {
    // 监听筛选条件变化，重置页码
    selectedDepartment() {
      this.visibleCount = this.pageStep;
    },
    selectedTitle() {
      this.visibleCount = this.pageStep;
    },
    selectedSpecialty() {
      this.visibleCount = this.pageStep;
    }
  }
}
</script>

<style scoped lang="scss">
.teachers-page {
  min-height: 100vh;
}

.teachers-banner {
  height: 300px;
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('@/assets/images/common-banner.jpg');
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
}

.banner-badges { margin-top: 12px; display: inline-flex; gap: 10px; }
.badge { padding: 6px 10px; border-radius: 999px; font-size: 12px; letter-spacing: 0.06em; background: rgba(255,255,255,0.14); border: 1px solid rgba(255,255,255,0.22); }

.banner-content h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.banner-content p {
  font-size: 1.5rem;
  opacity: 0.9;
}

.breadcrumb { background: transparent; padding: 12px 0; margin: 10px 0 24px; font-size: 0.95rem; }
.breadcrumb a { color: var(--default-red-color); text-decoration: none; }
.breadcrumb a:hover { text-decoration: underline; }

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

/* 师资概况 */
.teachers-intro {
  margin-bottom: 50px;
}

.intro-content {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
}

.intro-text {
  flex: 1;
  min-width: 300px;
}

.intro-text h2 {
  font-size: 2rem;
  margin-bottom: 20px;
  color: #333;
}

.intro-text p {
  margin-bottom: 20px;
  line-height: 1.6;
  color: #555;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 20px;
  margin-top: 30px;
}

.stat-item {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
}

.stat-item:hover {
  transform: translateY(-5px);
}

.stat-number {
  font-size: 2rem;
  font-weight: bold;
  color: var(--default-red-color);
  margin-bottom: 10px;
}

.stat-label {
  color: #555;
}

.intro-image {
  flex: 1;
  min-width: 300px;
  max-width: 500px;
}

.intro-image img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

/* 教师筛选 */
.teachers-filter {
  margin-bottom: 30px;
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
}

.filter-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.filter-group {
  flex: 1;
  min-width: 200px;
}

.filter-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
  color: #555;
}

.filter-group select,
.filter-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.search-group {
  flex: 1.5;
}

/* 教师列表 */
.teachers-list {
  margin-bottom: 50px;
}

.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.list-header h3 {
  font-size: 1.8rem;
  color: #333;
  margin-top: 0;
  margin-bottom: 0;
}

.sort-options {
  display: flex;
  align-items: center;
  gap: 10px;
}

.sort-options span {
  color: #555;
}

.sort-options button {
  background: none;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  color: #555;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.sort-options button:hover,
.sort-options button.active {
  background-color: #e9ecef;
  color: #007bff;
}

.teachers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 30px;
  margin-bottom: 30px;
}

.load-more { text-align: center; margin-top: 10px; }
.btn-outline { background: transparent; border: 2px solid var(--default-red-color); color: var(--default-red-color); padding: 10px 18px; border-radius: 6px; transition: all 0.25s ease; }
.btn-outline:hover { background: var(--default-red-color); color: #fff; }
.load-sentinel { height: 1px; }

.teacher-card {
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s, box-shadow 0.3s;
  cursor: pointer;
  position: relative;
}

.teacher-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

/* 卡片闪光层 */
.teacher-card.shiny::after { content: ''; position: absolute; top: -120%; left: -120%; width: 220%; height: 220%; background: linear-gradient(120deg, rgba(255,255,255,0) 42%, rgba(255,255,255,0.5) 50%, rgba(255,255,255,0) 58%); transform: rotate(10deg); transition: transform 0.6s ease, opacity 0.6s ease; opacity: 0; }
.teacher-card.shiny:hover::after { transform: rotate(10deg) translate(18%,18%); opacity: 1; }

.teacher-image {
  position: relative;
  height: 416px;
  overflow: hidden;
}

.teacher-image img {
  width: 100%;
  height: 100%;
  object-fit: inherit;
  transition: transform 0.5s;
}

.teacher-card:hover .teacher-image img {
  transform: scale(1.05);
}

.teacher-title {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 8px;
  text-align: center;
}

.teacher-info {
  padding: 10px 14px;
}

.teacher-info h4 {
  font-size: 1.2rem;
  margin-bottom: 8px;
  color: #333;
}

.teacher-info p {
  margin-bottom: 5px;
  color: #555;
  font-size: 0.9rem;
}

.teacher-honors {
  margin-top: 10px;
  display: flex;
  align-items: center;
  color: #ffc107;
  font-size: 0.9rem;
}

.teacher-honors i {
  margin-right: 5px;
}

/* 分页控制 */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.pagination button {
  background: none;
  border: 1px solid #ddd;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s;
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination button:hover:not(:disabled) {
  background-color: #f8f9fa;
}

.pagination span {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s;
}

.pagination span:hover {
  background-color: #f8f9fa;
}

.pagination span.active {
  background-color: #007bff;
  color: white;
}

/* 教师详情模态框 */
.teacher-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: linear-gradient(180deg, #ffffff, #f9fbfa);
  border-radius: 8px;
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 20px 60px rgba(0,0,0,0.35);
  border: 1px solid #eef2ef;
}

.close-button {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #555;
  z-index: 10;
}

.modal-header {
  display: flex;
  flex-wrap: wrap;
  padding: 30px;
  background: radial-gradient(600px 120px at 10% -10%, rgba(66,185,131,0.08), transparent),
              radial-gradient(700px 160px at 90% -10%, rgba(44,62,80,0.06), transparent);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.modal-image {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 30px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.modal-image img {
  width: 100%;
  height: 100%;
  object-fit: inherit;
}

.modal-title {
  flex: 1;
  min-width: 250px;
}

.modal-title h3 {
  font-size: 2rem;
  margin-bottom: 10px;
  color: #333;
}

.modal-title p {
  margin-bottom: 8px;
  color: #555;
}

.modal-title p.title {
  font-size: 1.2rem;
  color: #007bff;
  font-weight: bold;
}

.modal-body {
  padding: 30px;
}

.modal-body h4 {
  font-size: 1.5rem;
  margin-bottom: 15px;
  color: #333;
  border-bottom: 2px solid #f8f9fa;
  padding-bottom: 10px;
}

.bio-section {
  margin-bottom: 30px;
}

.bio-section p {
  line-height: 1.8;
  color: #555;
}

.education-section,
.honors-section {
  margin-bottom: 30px;
}

.education-section ul,
.honors-section ul {
  padding-left: 20px;
}

.education-section li,
.honors-section li {
  margin-bottom: 8px;
  color: #555;
  line-height: 1.6;
}

.courses-section {
  margin-bottom: 30px;
}

.courses-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.courses-tags span {
  background-color: #e9ecef;
  padding: 8px 15px;
  border-radius: 20px;
  color: #555;
  font-size: 0.9rem;
}

/* 模态入场动画 */
.modal-fade-zoom-enter-active, .modal-fade-zoom-leave-active { transition: all .25s ease; }
.modal-fade-zoom-enter, .modal-fade-zoom-leave-to { opacity: 0; transform: scale(.98); }

.teacher-wall {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: flex-start;
  margin-top: 6px;
  .wall-header {
    width: 100%;
    text-align: left;
    margin: 10px 0 6px;
    h3 {
      margin: 0;
      font-size: 1.6rem;
      color: #2c3e50;
    }
    p {
      margin: 4px 0 10px;
      color: #6b7a85;
    }
    .wall-divider {
      height: 4px;
      width: 120px;
      background: linear-gradient(90deg, var(--default-red-color), rgba(66,185,131,0));
      border-radius: 8px;
    }
  }
  .wall-teacher-card {
    width: 150px;
    text-align: center;
    cursor: pointer;
    height: 250px!important;
  }
  .wall-teacher-image img {
    width: 100%;
    height: 230px;
    object-fit: inherit;
    border-radius: 6px;
  }
  .wall-teacher-name {
    margin-top: 6px;
    font-size: 14px;
    font-weight: 500;
  }
}

.teacher-description {
  margin-top: 0.5rem;

  .teacher-line {
    margin: 0;
    line-height: 1.7;
    color: #555;
    text-indent: 2em; /* 每一行整体缩进 */
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .teachers-banner {
    height: 300px;
  }

  .banner-content h1 {
    font-size: 2rem;
  }

  .banner-content p {
    font-size: 1rem;
  }

  .filter-group {
    min-width: 100%;
  }

  .modal-header {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .modal-image {
    margin-right: 0;
    margin-bottom: 20px;
  }

  .teacher-image {
    height: unset;
  }

  .teacher-wall {
    .wall-teacher-card {
      width: 46%;
    }
  }
}
.pt-20 {
  padding-top: 20px;
}
</style>
